import type { Website } from '@integration-layer/index'

/**
 * Resolves an Amplience delivery key for the current website/brand.
 * Global website uses the base key; brand sites append `-{website}`.
 *
 * @example
 * resolveBrandDeliveryKey('alhena-chat-config', 'global') // 'alhena-chat-config'
 * resolveBrandDeliveryKey('alhena-chat-config', 'giorgio-armani') // 'alhena-chat-config-giorgio-armani'
 */
export function resolveBrandDeliveryKey(
  baseKey: string,
  website: Website
): string {
  return website !== 'global' ? `${baseKey}-${website}` : baseKey
}
